/**
 * DISCO Connect matcher
 * Radio-first: search or tap a radio → confirm plug → add to cart.
 * Dual-comm is optional. Kernel: one radio interface per CA unit.
 */
(function () {
  "use strict";

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function track(name, payload) {
    try {
      var data = Object.assign({ event: name }, payload || {});
      if (window.dataLayer) window.dataLayer.push(data);
      if (window.gtag) window.gtag("event", name, payload || {});
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        try {
          Shopify.analytics.publish(name, payload || {});
        } catch (e) {}
      }
    } catch (e) {}
  }

  function money(n) {
    if (n == null || n === "") return "";
    var x = Number(n);
    if (isNaN(x)) return "";
    return "$" + x.toFixed(x % 1 ? 2 : 0);
  }

  function normalize(s) {
    return String(s || "")
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "");
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function loadKernel(cfg) {
    if (window.D32_MATCH_KERNEL) return Promise.resolve(window.D32_MATCH_KERNEL);
    if (cfg.kernelInline) {
      try {
        return Promise.resolve(JSON.parse(cfg.kernelInline));
      } catch (e) {}
    }
    if (!cfg.kernelUrl) return Promise.reject(new Error("No match kernel"));
    return fetch(cfg.kernelUrl, { credentials: "same-origin" }).then(function (r) {
      if (!r.ok) throw new Error("kernel " + r.status);
      return r.json();
    });
  }

  function productJson(handle) {
    return fetch("/products/" + handle + ".js", { credentials: "same-origin" }).then(function (r) {
      if (!r.ok) throw new Error("product " + r.status);
      return r.json();
    });
  }

  function addToCart(variantId, qty, properties) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: qty || 1, properties: properties || {} }],
      }),
    }).then(function (r) {
      if (!r.ok)
        return r.json().then(function (err) {
          throw err;
        });
      return r.json();
    });
  }

  function openCartDrawer() {
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:updated"));
      var btn = document.querySelector('[data-drawer-open][data-drawer-view="cart-drawer"]');
      if (btn) btn.click();
    } catch (e) {}
  }

  function searchHits(kernel, q) {
    q = (q || "").trim();
    if (q.length < 1) return [];
    var nq = normalize(q);
    var qLower = q.toLowerCase();
    var sellable = kernel.sellable || {};
    var byToken = kernel.by_model_token || {};
    var codes = {};

    Object.keys(byToken).forEach(function (tok) {
      if (tok.indexOf(nq) !== -1 || nq.indexOf(tok) !== -1) {
        (byToken[tok] || []).forEach(function (c) {
          if (sellable[c]) codes[c] = true;
        });
      }
    });

    Object.keys(sellable).forEach(function (code) {
      var row = sellable[code];
      var blob = (
        code +
        " " +
        (row.manufacturer || "") +
        " " +
        (row.interface_name || "") +
        " " +
        (row.radio_examples || []).join(" ") +
        " " +
        (row.ca && row.ca.title ? row.ca.title : "")
      ).toLowerCase();
      if (blob.indexOf(qLower) !== -1) codes[code] = true;
    });

    return Object.keys(codes)
      .map(function (c) {
        return { code: c, row: sellable[c] };
      })
      .filter(function (x) {
        return x.row;
      })
      .slice(0, 24);
  }

  function primaryOffer(row) {
    var ca = row.ca || {};
    var caOk = ca.handle && ca.live !== false;
    if (caOk) {
      return { kind: "ca", handle: ca.handle, title: ca.title, price: ca.price, sku: ca.sku };
    }
    if (row.msm_handle) {
      return {
        kind: "msm",
        handle: row.msm_handle,
        title: "Modular Speaker Mic (" + (row.interface_code || "HA") + ")",
        price: row.msm_price,
        sku: null,
      };
    }
    var leg = row.legacy || {};
    if (leg.handle) {
      return { kind: "u94", handle: leg.handle, title: leg.title, price: leg.price, sku: null };
    }
    return null;
  }

  function warningsFor(kernel, code, state) {
    var out = [];
    var w = kernel.warnings || {};
    if (w[code]) out = out.concat(w[code]);
    if (state.headset === "discus_risk" && w.DISCUS) out = out.concat(w.DISCUS);
    if (state.headset === "legacy_u94") {
      out.push(
        "U-94: mic type matters (dynamic needs amp). Constant Able auto-senses impedance — preferred when we sell it for this plug."
      );
    }
    if (state.dual === "yes") {
      if (w.DUAL) out = out.concat(w.DUAL);
      else
        out.push(
          "Two radios: dual mono usually means two PTTs (one per radio plug). Stereo / MPU5 / 5-pole is a different path."
        );
    }
    var seen = {};
    return out.filter(function (t) {
      if (!t || seen[t]) return false;
      seen[t] = true;
      return true;
    });
  }

  function setSteps(root, active) {
    $$(".d32m__step-pill", root).forEach(function (el, i) {
      el.classList.toggle("is-active", i === active);
    });
  }

  function whyLine(hit, offer) {
    var code = hit.code;
    var extras = {
      M9: "Classic APX 1000–8000 and XPR 6000/7000 GCAI. Not Mini GCAI (N70 / R7 / Ion — that is M16).",
      M16: "Mini GCAI for APX N30/N50/N70, MOTOTRBO R7, and Ion. Classic APX 6000/8000 is M9.",
      M4: "XTS / Jedi universal connector. APX GCAI is M9.",
      M11: "MiniTRBO Slim (XPR 3000/3300/3500). XPR 6000/7000 GCAI is M9. SL Series is M10.",
      M3: "EX500 / GP328 Plus / HD1. Original HT-1250 is M2.",
      K1: "Kenwood 2-pin and UV-5R-style jacks. NX-5000 universal is K2.",
      K2: "Kenwood universal / NX-5000. Not the 2-pin K1 jack.",
      HA2: "Harris XL-200 / XL-185 / XG-100 9-pin UDC. XG-75 15-pin is HA1.",
      HA1: "Harris XG-75 / P5500 15-pin UDC. XL-200 is HA2. Constant Able HA1 is not listed — speaker mic is in stock.",
      NATO: "PRC-152 / PRC-148 6-pin. Enable accessory voltage; set mic to Lapel Mic.",
      H4: "Hytera 13-pin HP600/PD60x. PD70x 16-pin is H3.",
    };
    var base =
      offer.kind === "msm"
        ? "Shoulder mic for this radio plug, with a headset port."
        : "Headset jack is U-174 — NATO or Peltor wired, high or low impedance. One radio plug per unit.";
    return (extras[code] || base) + (extras[code] ? "" : "");
  }

  function renderMatch(root, kernel, hit, state, cfg) {
    var box = $(".d32m__match-out", root);
    if (!box || !hit) return;
    setSteps(root, 2);
    var offer = primaryOffer(hit.row);
    if (!offer) {
      box.innerHTML =
        '<div class="d32m__card"><h3>We need a photo of that jack</h3><p class="why">This radio family is not a one-click match. Email help@disco32.com with the radio model and a photo of the accessory plug.</p><div class="d32m__actions"><a class="d32m__btn" href="mailto:help@disco32.com">Email help@disco32.com</a></div></div>';
      return;
    }
    var qty = state.dual === "yes" && state.dualPath === "dual_mono" ? 2 : 1;
    var warns = warningsFor(kernel, hit.code, state);
    var ca = hit.row.ca || {};
    var msmH = hit.row.msm_handle;
    var u94 = hit.row.legacy && hit.row.legacy.handle ? hit.row.legacy : null;
    var examples = (hit.row.radio_examples || []).slice(0, 6).join(", ");

    box.innerHTML =
      '<div class="d32m__card d32m__card--result" data-handle="' +
      escapeHtml(offer.handle) +
      '" data-code="' +
      escapeHtml(hit.code) +
      '" data-qty="' +
      qty +
      '">' +
      '<div class="d32m__card-grid">' +
      '<div class="d32m__card-media" data-media></div>' +
      "<div>" +
      '<p class="d32m__kicker">' +
      escapeHtml(hit.code) +
      " · " +
      escapeHtml(hit.row.manufacturer || "") +
      "</p>" +
      "<h3>" +
      escapeHtml(offer.title || "Match") +
      "</h3>" +
      '<div class="price" data-price>' +
      (money(offer.price) || "") +
      (qty > 1 ? " each" : "") +
      "</div>" +
      '<p class="d32m__stock" data-stock>Checking stock…</p>' +
      (examples ? '<p class="why">Fits: ' + escapeHtml(examples) + "</p>" : "") +
      '<p class="why">' +
      escapeHtml(whyLine(hit, offer)) +
      "</p>" +
      (qty === 2
        ? '<p class="why"><strong>Two radios, same plug:</strong> cart will get qty 2. Different plugs = match each radio.</p>'
        : "") +
      warns
        .map(function (t) {
          return '<div class="d32m__warn">' + escapeHtml(t) + "</div>";
        })
        .join("") +
      '<div class="d32m__actions">' +
      (state.dualPath === "stereo"
        ? '<a class="d32m__btn" href="' +
          escapeHtml(cfg.contactUrl || "/pages/contact") +
          '">Contact for dual-comm</a>'
        : '<button type="button" class="d32m__btn d32m__atc" data-atc>Add to cart' +
          (qty > 1 ? " (×2)" : "") +
          "</button>") +
      '<a class="d32m__btn d32m__btn--ghost" href="/products/' +
      escapeHtml(offer.handle) +
      '">View product</a>' +
      (msmH && offer.handle !== msmH
        ? '<a class="d32m__btn d32m__btn--ghost" href="/products/' +
          escapeHtml(msmH) +
          '">Speaker mic instead</a>'
        : "") +
      (u94 && u94.handle !== offer.handle
        ? '<a class="d32m__btn d32m__btn--ghost" href="/products/' +
          escapeHtml(u94.handle) +
          '">U-94 option</a>'
        : "") +
      '<a class="d32m__btn d32m__btn--ghost" href="' +
      escapeHtml(cfg.contactUrl || "/pages/contact") +
      '">Request a quote</a>' +
      "</div>" +
      '<p class="d32m__atc-status d32m__empty" role="status" hidden></p>' +
      "</div></div></div>";

    try {
      box.scrollIntoView({ behavior: "smooth", block: "nearest" });
    } catch (e) {}

    var atcBtn = $(".d32m__atc", box);
    if (atcBtn) {
      atcBtn.addEventListener("click", function () {
        doAtc(box, offer.handle, hit, qty, state);
      });
    }

    productJson(offer.handle)
      .then(function (prod) {
        var v =
          (prod.variants || []).find(function (x) {
            return x.available;
          }) || (prod.variants || [])[0];
        var media = $("[data-media]", box);
        var img = (prod.featured_image || (prod.images && prod.images[0]) || "") + "";
        if (media && img) {
          media.innerHTML =
            '<img src="' +
            escapeHtml(img.replace(/(\.[a-z]+)(\?|$)/i, "_480x$1$2")) +
            '" alt="' +
            escapeHtml(prod.title || "") +
            '" width="480" height="480">';
        }
        var stock = $("[data-stock]", box);
        var avail = v && v.available;
        if (stock) {
          stock.textContent = avail ? "In stock — ships from Aberdeen, NC" : "Currently unavailable — request a quote";
          stock.classList.toggle("is-out", !avail);
        }
        var priceEl = $("[data-price]", box);
        if (priceEl && v && v.price != null) {
          var p = Number(v.price);
          if (!isNaN(p)) priceEl.textContent = money(p / 100) + (qty > 1 ? " each" : "");
        }
        if (!avail && atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = "Out of stock";
        }
      })
      .catch(function () {
        var stock = $("[data-stock]", box);
        if (stock) stock.textContent = "Open the product page to confirm stock.";
        if (atcBtn && offer.kind === "ca" && hit.code === "HA1") {
          atcBtn.disabled = true;
          atcBtn.textContent = "Not listed";
        }
      });

    track("connect_result_view", {
      interface: hit.code,
      handle: offer.handle,
      kind: offer.kind,
      dual: state.dual || "no",
      dual_path: state.dualPath || "single",
      qty: qty,
    });
  }

  function doAtc(card, handle, hit, qty, state) {
    var btn = $(".d32m__atc", card);
    var status = $(".d32m__atc-status", card);
    if (!btn) return;
    btn.disabled = true;
    btn.textContent = "Adding…";
    if (status) {
      status.hidden = false;
      status.textContent = "Adding to cart…";
    }
    productJson(handle)
      .then(function (prod) {
        var v =
          (prod.variants || []).find(function (x) {
            return x.available;
          }) || prod.variants[0];
        if (!v) throw new Error("No variant");
        if (!v.available) throw new Error("unavailable");
        return addToCart(v.id, qty, {
          _d32_connect: hit.code,
          _d32_dual: state.dual || "no",
        });
      })
      .then(function () {
        track("connect_atc", { interface: hit.code, handle: handle, qty: qty });
        if (status) {
          status.textContent = "Added. ";
          var a = document.createElement("a");
          a.href = "/cart";
          a.textContent = "View cart";
          status.appendChild(a);
        }
        btn.textContent = "Added";
        btn.disabled = false;
        openCartDrawer();
      })
      .catch(function (err) {
        track("connect_atc_error", { interface: hit.code, message: String(err && err.message) });
        if (status) {
          status.textContent = "Could not add here — open the product page.";
        }
        btn.disabled = false;
        btn.textContent = "Add to cart" + (qty > 1 ? " (×2)" : "");
      });
  }

  function boot(root) {
    var cfgEl = document.getElementById(root.getAttribute("data-config-id") || "");
    var cfg = {};
    try {
      cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    } catch (e) {
      cfg = {};
    }

    var state = { dual: "no", dualPath: "single", headset: "any", hit: null };
    var search = $(".d32m__search", root);
    var list = $(".d32m__results", root);
    var status = $(".d32m__status", root);
    var radioWrap = $(".d32m__radio-step", root);
    if (!search || !list) return;

    if (radioWrap) radioWrap.hidden = false;
    var hsWrap = $(".d32m__headset", root);
    if (hsWrap) hsWrap.hidden = false;

    track("connect_start", { mode: "connect" });
    setSteps(root, 0);

    function selectHit(kernel, hit, source) {
      state.hit = hit;
      $$(".d32m__quick", root).forEach(function (b) {
        b.classList.toggle("is-selected", b.getAttribute("data-quick") === hit.code);
      });
      track("connect_radio_selected", { interface: hit.code, source: source || "search" });
      renderMatch(root, kernel, hit, state, cfg);
    }

    function paintHits(kernel, hits) {
      list.innerHTML = "";
      if (!hits.length) {
        list.innerHTML =
          '<li><button type="button" disabled class="d32m__empty">No match — try APX 8000, N70, XL-200, UV-5R, PRC-152, or email help@disco32.com.</button></li>';
        return;
      }
      hits.forEach(function (hit, idx) {
        var li = document.createElement("li");
        var btn = document.createElement("button");
        btn.type = "button";
        btn.setAttribute("role", "option");
        var examples = (hit.row.radio_examples || []).slice(0, 4).join(", ");
        var offer = primaryOffer(hit.row);
        btn.innerHTML =
          '<span class="code">' +
          escapeHtml(hit.code) +
          "</span> " +
          escapeHtml((offer && offer.title) || hit.code) +
          (examples
            ? '<div class="d32m__hit-ex">' + escapeHtml(examples) + "</div>"
            : "");
        btn.addEventListener("click", function () {
          selectHit(kernel, hit, "search");
        });
        if (idx === 0) btn.setAttribute("data-first", "1");
        li.appendChild(btn);
        list.appendChild(li);
      });
    }

    $$("[data-dual]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        $$("[data-dual]", root).forEach(function (b) {
          b.classList.toggle("is-selected", b === btn);
        });
        state.dual = btn.getAttribute("data-dual");
        track("connect_dual", { dual: state.dual });
        var pathEl = $(".d32m__dual-path", root);
        if (state.dual === "yes") {
          if (pathEl) pathEl.hidden = false;
        } else {
          state.dualPath = "single";
          if (pathEl) pathEl.hidden = true;
        }
        if (state.hit) renderMatch(root, window.D32_MATCH_KERNEL, state.hit, state, cfg);
      });
    });

    $$("[data-dual-path]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        $$("[data-dual-path]", root).forEach(function (b) {
          b.classList.toggle("is-selected", b === btn);
        });
        state.dualPath = btn.getAttribute("data-dual-path");
        track("connect_dual_path", { dual_path: state.dualPath });
        if (state.dualPath === "stereo") {
          var box = $(".d32m__match-out", root);
          if (box) {
            box.innerHTML =
              '<div class="d32m__card"><h3>Stereo / platform dual-comm</h3>' +
              '<p class="why">MPU5, stereo U384/5-pole, PRC-163 dual, and similar paths are <strong>not</strong> a single mono Constant Able. Send radio models and a headset photo — we will map the downleads.</p>' +
              '<div class="d32m__actions"><a class="d32m__btn" href="' +
              escapeHtml(cfg.contactUrl || "/pages/contact") +
              '">Talk to DISCO32</a>' +
              '<a class="d32m__btn d32m__btn--ghost" href="mailto:help@disco32.com">Email help@disco32.com</a></div></div>';
            setSteps(root, 2);
          }
          track("connect_dead_end", { reason: "stereo_platform" });
          return;
        }
        if (state.hit) renderMatch(root, window.D32_MATCH_KERNEL, state.hit, state, cfg);
      });
    });

    $$("[data-headset]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        $$("[data-headset]", root).forEach(function (b) {
          b.classList.toggle("is-selected", b === btn);
        });
        state.headset = btn.getAttribute("data-headset") || "any";
        track("connect_headset", { headset: state.headset });
        if (state.hit) renderMatch(root, window.D32_MATCH_KERNEL, state.hit, state, cfg);
      });
    });

    loadKernel(cfg)
      .then(function (kernel) {
        window.D32_MATCH_KERNEL = kernel;
        if (status) {
          status.textContent = "Search a radio model or choose one below.";
          status.classList.remove("d32m__empty");
        }

        $$("[data-quick]", root).forEach(function (btn) {
          btn.addEventListener("click", function () {
            var code = (btn.getAttribute("data-quick") || "").toUpperCase();
            if (!kernel.sellable || !kernel.sellable[code]) return;
            search.value = btn.textContent.trim();
            selectHit(kernel, { code: code, row: kernel.sellable[code] }, "quick");
          });
        });

        try {
          var u = new URL(window.location.href);
          var iface = (u.searchParams.get("interface") || "").toUpperCase();
          var q = u.searchParams.get("q") || u.searchParams.get("radio") || "";
          var dualQ = (u.searchParams.get("dual") || "").toLowerCase();
          if (dualQ === "1" || dualQ === "yes") {
            var dYes = $('[data-dual="yes"]', root);
            if (dYes) dYes.click();
          }
          if (iface && kernel.sellable && kernel.sellable[iface]) {
            selectHit(kernel, { code: iface, row: kernel.sellable[iface] }, "deeplink");
          } else if (q) {
            search.value = q;
            var hits = searchHits(kernel, q);
            paintHits(kernel, hits);
            if (hits.length === 1) selectHit(kernel, hits[0], "query");
          }
        } catch (e) {}

        try {
          search.focus({ preventScroll: true });
        } catch (e) {}

        var t = null;
        function run() {
          setSteps(root, 1);
          var hits = searchHits(kernel, search.value);
          paintHits(kernel, hits);
        }

        search.addEventListener("input", function () {
          clearTimeout(t);
          t = setTimeout(run, 80);
        });
        search.addEventListener("keydown", function (e) {
          if (e.key === "Enter") {
            e.preventDefault();
            run();
            var first = $("[data-first]", list);
            if (first) first.click();
          }
          if (e.key === "ArrowDown") {
            e.preventDefault();
            var b = $("button[role='option']", list);
            if (b) b.focus();
          }
        });
      })
      .catch(function (err) {
        if (status) {
          status.textContent =
            "Search is temporarily unavailable. Use the table below or email help@disco32.com.";
        }
        console.warn("[d32-match]", err);
      });
  }

  function init() {
    document.querySelectorAll("[data-d32-match]").forEach(boot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
